<template>
  <article class="card" v-hammer:pan="handlePanStart" v-hammer:panend="handlePanEnd" v-hammer:tap="handleTap">
    <div class="photo" :style="image">
      <div class="is-liking" v-show="action === 'is-liking'">
        <img src="@/assets/icons/heart.svg" alt="">
      </div>
      <div class="is-disliking" v-show="action === 'is-disliking'">
        <img src="@/assets/icons/cancel-white.svg" alt="">
      </div>
      <tag color="red">{{ property.ContractType }}</tag>
      <tag>{{ property.TransactionType }}</tag>
    </div>
    <span class="title">{{ property.TotalBedrooms }} Bedroom {{ property.PropertyType }}</span>
    <span class="price">{{ property.Price | formatPrice }}</span>
    <span class="location">{{ property.Town }}, Malta</span>
  </article>
</template>

<style scoped lang="scss">
  .card {
    display: flex;
    flex-direction: column;
    width: calc(100vw - 40px);
    height: 360px;
    padding: 15px;
    border-radius: 4px;
    box-shadow: 0 8px 20px 10px rgba(0, 0, 0, 0.1);
    background-color: rgb(var(--white));

    @include min-sm {
      width: 405px;
      height: 425px;
    }

    .photo {
      position: relative;
      width: 100%;
      height: 75%;
      margin-bottom: 15px;
      padding: 10px;
      border-radius: 2px;
      background-size: cover;
      background-position: center;
      
      .is-liking,
      .is-disliking {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 10px;
        border-radius: 2px;

        img {
          width: 3rem;
          height: 3rem;
        }
      }

      .is-liking {
        background-image: linear-gradient(311deg, rgba(255, 125, 137, 0) 50%, rgb(var(--red-0)));
      }

      .is-disliking {
        background-image: linear-gradient(-311deg, rgba(64, 64, 65, 0) 50%, #404041);

        text-align: right;
      }
    }
    
    .title,
    .price,
    .location {
      display: block;
      margin-bottom: 5px;
      color: rgb(var(--gray-20));
    }

    .title {
      order: 1;
      font-size: var(--h4);
      font-weight: var(--weight-bold);
    }

    .price {
      order: 0;
      font-size: var(--h3);
      font-weight: var(--weight-bold);
    }

    .location {
      order: 2;
      font-size: var(--h4);
    }
  }
</style>

<script>
  import { formatPrice } from '@/filters';
  import Tag from '@/components/Tag';

  const $_pan_threshold = 100;

  export default {
    name: 'CardProprety',

    components: {
      Tag
    },

    filters: {
      formatPrice
    },

    props: {
      property: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      action: ''
    }),

    computed: {
      image () {
        return `background-image: url('${ this.property.Image }')`
      }
    },

    methods: {
      handlePanStart (e) {
        let x = e.deltaX;
        let y = e.deltaY;
        let r = x > 15 ? 15 : x < -15 ? -15 : x;

        this.$el.style.transition = 'transform 0.1s';
        this.$el.style.transform = `translate3d(${ x }px, ${ y }px, 0) rotate(${ r }deg)`;

        if (e.distance > $_pan_threshold) return x < 0 ? this.action = 'is-disliking' : this.action = 'is-liking';

        this.action = '';
      },

      handlePanEnd (e) {
        // Remove transition so "drop" animation plays smoothly
        this.$el.style.transition = '';

        if (e.distance < $_pan_threshold) { 
          this.$el.style.transform = '';
          this.action = '';
          return
        }

        (e.deltaX < 0 ? this.$emit('left') : this.$emit('right'));
      },

      handleTap () {
        this.$router.push(`/properties/${ this.property.MLS }`)
      }
    }
  };
</script>